module.exports = __webpack_public_path__ + "theme/assets/img/d93d12d6722eaf6f69e5f01118e2fcd3.jpg";